import React, { Component } from 'react';
import { Page } from './components/affichage/Page';

export default class App extends Component {
    obtenirVariablesGlobales() { return []; }

    render() {
        const chemin = window.location.pathname;
        if (!chemin.includes('/Presentation') && !chemin.includes('/Article')) {
            window.location.pathname = '/Presentation';
        }
        return <Page />;
    }
}

